module.exports = __webpack_public_path__ + "img/allocate-icon-small.dd747872.png";